<template lang="pug">
.room-schedule-setting-example-modal
  b-modal(ref="modal" size="xl" no-close-on-backdrop no-close-on-esc hide-footer scrollable)
    .room-schedule-setting-example-modal-header(slot="modal-header" slot-scope="{ cancel }")
      .float-left.title
        span 空室／空床情報の公開設定の設定例
      .float-right
        button(type="button" class="close" @click="cancel()") ×
    .room-schedule-setting-example-modal-body
      span.title ケアマネ等に公開する空室／空床情報の公開内容を設定できます
      ul.detail-item
        li
          span.item 公開状態
          span ：非公開にすると、公開開始日／公開終了日に関係なく非公開になります。
        li
          span.item 公開開始日
          span ：開始日より前の日は
          span.item TEL
          span と表示されます（開始日以降のみ〇×表示）。
        li
          span.item 公開終了日
          span ：公開終了日まで〇×表示されます。
          span.item 未指定も可
          span で、その場合は全て公開になります。
        li
          span.item 連絡事項
          span ：空室／空床情報の公開アプリ上で
          span.item 伝えたい補足事項
          span を記載してください。
      b-img.image(src="@/assets/room-schedule-setting-example.png" fluid)
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

/**
 * 空室／空床情報の公開設定の使用例モーダル
 */
@Component
export default class RoomScheduleSettingExampleModal extends Vue {
  /**
   * モーダル表示
   */
  public show(): void {
    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }

    return;
  }
}
</script>
